/**
 * Helpers for parsing provider-prefixed health metric keys.
 * A key looks like "oura/restingHeartRate" — provider before the slash, metric after.
 */

/** Extract the metric name from a provider-prefixed key like "oura/restingHeartRate" → "restingHeartRate" */
export function metricOf(key: string): string {
  const slash = key.indexOf('/');
  return slash >= 0 ? key.slice(slash + 1) : key;
}

/** Extract the provider from a provider-prefixed key like "oura/restingHeartRate" → "oura" */
export function providerOf(key: string): string {
  const slash = key.indexOf('/');
  return slash >= 0 ? key.slice(0, slash) : '';
}
